import { IStarSlashIconProps } from "interfaces";

const StarSlashIcon = ({ className, onClick }: IStarSlashIconProps) => {
    return (
        <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} onClick={onClick}>
            <path
                d="M9.3501 7.22928C9.1751 7.40428 9.0751 7.75428 9.1301 7.99428L9.4751 9.50428C9.6201 10.1293 9.5301 10.5993 9.2201 10.8243C9.0951 10.9143 8.9451 10.9593 8.7701 10.9593C8.5151 10.9593 8.2151 10.8643 7.8851 10.6693L6.4201 9.79928C6.1901 9.66428 5.8101 9.66428 5.5801 9.79928L4.1151 10.6693C3.5601 10.9943 3.0851 11.0493 2.7801 10.8243C2.7601 10.8093 2.7401 10.7943 2.7251 10.7743L9.0351 4.46428C9.2651 4.23428 9.5901 4.12928 9.9101 4.18428L9.9851 4.19928C10.5151 4.28928 10.8701 4.52928 10.9851 4.87928C11.0951 5.22928 10.9451 5.63428 10.5651 6.01428L9.3501 7.22928Z"
                fill="#FFBA02"
            />
            <path
                d="M2.87017 8C2.92517 7.76 2.82517 7.405 2.65017 7.23L1.43517 6.015C1.05517 5.635 0.905174 5.23 1.01517 4.88C1.13017 4.53 1.48517 4.29 2.01517 4.2L3.57517 3.94C3.80017 3.9 4.07517 3.7 4.18017 3.495L5.04017 1.77C5.29017 1.275 5.63017 1 6.00017 1C6.37017 1 6.71017 1.275 6.96017 1.77L7.82017 3.495C7.88517 3.625 8.02017 3.75 8.16517 3.835L2.53517 9.465L2.87017 8Z"
                fill="#FFBA02"
            />
        </svg>
    );
};

export default StarSlashIcon;
